import type {MembershipApiModel} from '../../../api/membership';
import type {
  CoreClientMembershipsListParams,
  CoreCoachMembershipsListParams,
} from '../../../api/types/core/methods';
import type {BaseConfig} from '../utils';

import {apiRequest} from '../../../api/utils/apiRequest';
import {AppError} from '../../../utils/errors/app';
import {expandResponse} from '../utils';

export {membershipFetchList};

type ClientConfig = BaseConfig<CoreClientMembershipsListParams>;

type CoachConfig = BaseConfig<CoreCoachMembershipsListParams>;

async function membershipFetchList(
  _config: any,
): Promise<MembershipApiModel[]> {
  throw new AppError(
    'Common strategy is not defined! Call strategy for specific role directly: membershipFetchList.asClient()',
  );
}

membershipFetchList.asClient = asClient;
membershipFetchList.asCoach = asCoach;

async function asClient(config: ClientConfig): Promise<MembershipApiModel[]> {
  const response = await apiRequest<CoreClientMembershipsListParams>({
    method: 'client.memberships.list',
    ...config,
  });

  return expandResponse(response, config);
}

async function asCoach(config: CoachConfig): Promise<MembershipApiModel[]> {
  const response = await apiRequest<CoreCoachMembershipsListParams>({
    method: 'coach.memberships.list',
    ...config,
  });

  return expandResponse(response, config);
}
